var module = angular.module('octopusApp.projects');

import React from 'react';
import ReactCSSTransitionGroup from 'react/lib/ReactCSSTransitionGroup';
import {Button, Modal} from 'react-bootstrap';
import StepTemplate from 'step_template';
import StepTemplateCategory from 'step_template_category';

var StepTemplates = React.createClass({
    propTypes: {
        templates: React.PropTypes.array.isRequired,
        onAdditionRequested: React.PropTypes.func.isRequired,
        addButtonName: React.PropTypes.string,
        onInstallationRequested: React.PropTypes.func.isRequired,
        installButtonName: React.PropTypes.string,
        onUpdateRequested: React.PropTypes.func.isRequired,
        onDetailsRequested: React.PropTypes.func.isRequired,
        resolveLink: React.PropTypes.func.isRequired,
        enableGrouping: React.PropTypes.bool
    },
    categoriseTemplates: function(templates){
        var categorised = _.groupBy(templates, t => { return t.Category; });
        return _.keys(categorised).sort(function(category1, cateogry2) { return category1.toLowerCase().localeCompare(cateogry2.toLowerCase()); }).map(categoryName => { return {name: categoryName, templates : categorised[categoryName]};});
    },
    getInitialState: function() {
        return {
            showModal: false,
            templateId: '',
            templateName: '',
            categoryTemplates: [],
            categories: this.categoriseTemplates(this.props.templates)
        };
    },
    popupConfirmation: function(templateId, templateName) {
        this.setState({ templateId: templateId });
        this.setState({ templateName: templateName });
        this.setState({ showModal: true });
    },
    showDetails: function() {
        this.props.onDetailsRequested(this.state.templateId);
    },
    installStepAndAdd: function() {
        this.props.onInstallationRequested(this.state.templateId).then(this.close(), this.close());
    },
    close: function() {
        this.setState({ showModal: false });
    },
    showCategoryTemplates: function(templates) {
        // We are setting min-hight here to avoid "screen jumping" when the user switches from categories to templates.
        // Ideally this would be handled by a CSS transform but it did not work.
        this.categoryTemplatesElement.style.minHeight = this.categoriesElement.clientHeight + "px";
        this.setState({categoryTemplates: templates, categories: []});

    },
    showCategories: function() {
        this.setState({categoryTemplates: [], categories: this.categoriseTemplates(this.props.templates)});
    },
    showAllTemplates: function() {
        this.setState({categoryTemplates: this.props.templates, categories: []});
    },
    componentWillReceiveProps: function(nextProps){
        this.setState({categories: this.categoriseTemplates(nextProps.templates)});
    },
    isInCategoryMode: function(){
        return this.state.categoryTemplates.length === 0 && this.state.categories.length > 0;
    },
    isInCategoryTemplatesMode: function(){
        return this.state.categoryTemplates.length > 0 && this.state.categories.length === 0;
    },
    render: function() {
        return <div>
            { this.props.enableGrouping ?
                <div>
                    {this.isInCategoryMode() && <button className="btn btn-link pull-right" onClick={this.showAllTemplates}>Show all</button>}
                    {this.isInCategoryTemplatesMode() && <button className="btn btn-link pull-right" onClick={this.showCategories}>Back</button>}
                    <div className="grouping-container">
                        <ol className="categories" ref={(element) => this.categoriesElement = element}  >
                            <ReactCSSTransitionGroup
                                transitionName={{enter: 'zoomIn', leave: 'zoomOut' }}
                                transitionEnterTimeout={1000}
                                transitionLeaveTimeout={1000}>
                                {this.state.categories.map(category => {
                                    return <StepTemplateCategory key={category.name} name={category.name} templates={category.templates}
                                                                 resolveLink={this.props.resolveLink}
                                                                 onCategorySelected={() => this.showCategoryTemplates(category.templates)}/>;
                                })}
                            </ReactCSSTransitionGroup>
                        </ol>
                        <ol className="category-templates" ref={(element) => this.categoryTemplatesElement = element}>
                            <ReactCSSTransitionGroup
                                transitionName={{enter: 'fadeIn', leave: 'fadeOut'}}
                                transitionEnterTimeout={1000}
                                transitionLeaveTimeout={1000}
                            >
                                {this.state.categoryTemplates.map(template => {
                                    return <StepTemplate key={template.key} template={template}
                                                         onAdditionRequested={() => this.props.onAdditionRequested(template.Type, template.Id)}
                                                         addButtonName={this.props.addButtonName}
                                                         onInstallationRequested={() => this.popupConfirmation(template.Id, template.Name)}
                                                         installButtonName={this.props.installButtonName}
                                                         onUpdateRequested={() => this.props.onUpdateRequested(template.CommunityActionTemplateId)}
                                                         onDetailsRequested={() => this.props.onDetailsRequested(template.Id)}
                                                         resolveLink={this.props.resolveLink}/>;
                                })}
                            </ReactCSSTransitionGroup>
                        </ol>
                    </div>
                </div>
                 :
                <ol>
                    {this.props.templates.map(template => {
                        return <StepTemplate key={template.key} template={template}
                                             onAdditionRequested={() => this.props.onAdditionRequested(template.Type, template.Id)} addButtonName={this.props.addButtonName}
                                             onInstallationRequested={() => this.popupConfirmation(template.Id, template.Name)} installButtonName={this.props.installButtonName}
                                             onUpdateRequested ={() => this.props.onUpdateRequested(template.CommunityActionTemplateId)}
                                             onDetailsRequested={() => this.props.onDetailsRequested(template.Id)}
                                             resolveLink={this.props.resolveLink}/>;
                    })}
                </ol>
            }
            <Modal show={this.state.showModal} onHide={this.close}>
                <Modal.Header closeButton>
                    <h3>{this.props.installButtonName ? this.props.installButtonName : 'Install and add step'}</h3>
                </Modal.Header>
                <Modal.Body>
                    <h4>{this.state.templateName}</h4>
                    <div className="alert alert-info margin margin-top-10" role="alert">This is a community contributed step that will be installed into your <a className="alert-link" href="#/library/steptemplates">Step templates</a> library. Read our <a className="alert-link" href="http://g.octopushq.com/CommunityContributedStepTemplates" target="_blank">community step documentation</a> for more information.</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-link pull-left" onClick={this.showDetails}>View details</button>
                    <Button onClick={this.close}>Cancel</Button>
                    <Button className="btn btn-success" onClick={this.installStepAndAdd}>{this.props.installButtonName ? this.props.installButtonName : 'Install and add'}</Button>
                </Modal.Footer>
            </Modal>
        </div>;
    }
});

module.directive('stepTemplates', function (reactDirective) {
    return reactDirective(StepTemplates);
});






// WEBPACK FOOTER //
// ./app/areas/projects/step-templates/step_templates.jsx